<template>
    <div class="school-index" ref="schoolIndex">
        <van-nav-bar class="navBar" :left-text="$t('text.return')" @click-left="exit" fixed left-arrow>
        <template #left>
            <van-icon name="arrow-left" />
            {{$t('business_school.business_school')}}
        </template>
        <template #right>
            <van-icon @click="toPage('/search-case')" name="search" size="20" />
        </template>
        </van-nav-bar>


        <div class="sorts isTop" v-show="isTop">
            <div class="sort" @click="showSort = !showSort">
                {{$t('business_school.category')}}: {{courseName}}
                <svg-icon icon-class="triangle"></svg-icon>
            </div>
        </div>

        <div class="content">

            <div class="swipe">
                <van-swipe :autoplay="3000" lazy-render>
                    <van-swipe-item v-for="item in bannerImg" :key="item.img">
                        <img :src="$utils.setSourcePath(item.img)" />
                        <div class="title">
                            <h4>{{item.title}}</h4>
                            <sd-button mini  @click.native="toPage('/learn-detail?id='+item.id)">{{$t('text.learn')}}</sd-button>
                        </div>
                    </van-swipe-item>
                </van-swipe>
                <div class="TeacherApply">
                    <van-icon name="manager-o" />
                    <div class="apply">
                        <h6>{{$t('business_school.become_lecturer')}}</h6>
                        <sd-button mini @click.native="toPage('/survey')">{{$t('text.apply')}}</sd-button>
                    </div>
                </div>
                <!-- <van-image :height="'400px'" :width="'20vw'" src="https://fastly.jsdelivr.net/npm/@vant/assets/apple-3.jpeg"/> -->
            </div>

            <div class="picke">
                <div class="sorts">
                    <div class="sort" @click="showSort = !showSort">
                        {{$t('business_school.category')}}: {{courseName}}
                        <svg-icon icon-class="triangle"></svg-icon>
                    </div>
                </div>
            </div>

            <div class="grid">
                <van-grid :gutter="18" :column-num="columnNum">
                    <van-grid-item @click="toPage('/learn-detail?id='+course.id)" v-for="course in courses" :key="course.id" >
                        <div class="course">
                            <div class="coursePre">
                                <van-image fit="fill" :src="$utils.setSourcePath(course.preview)">
                                <template v-slot:error>
                                    <!-- <img src="@/assets/img/nodata2.png"/> -->
                                </template>
                                </van-image>
                                <div class="pic-info">
                                    <div class="value">{{course.typeName}}</div>
                                </div>
                            </div>
                            <div class="title ellipsis2">{{course.title}}</div>
                            <div class="tip">
                                <div class="time">
                                    <van-icon name="underway-o" color="#ee0a24" />
                                    {{course.length}}min
                                </div>
                                <sd-button class="detailButton" mini>{{$t('text.learn')}}</sd-button>
                            </div>
                        </div>
                    </van-grid-item>
                </van-grid>
            </div>
        </div>

        <div class="tabbar" @click="toPage('/my-learn')">
            <sd-button mini class="footBtn">{{$t('business_school.my_learning')}}</sd-button>
        </div>
        <sd-sort :list="sortData" v-if="showSort" :value="courseId" class="page-sort isTop" @choose="setSort" @cancel="showSort"></sd-sort>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "cases",
    components: {  },
    data() {
        return {
            bannerImg: [],
            courses: [],
            isTop: false,
            showSort: false,
            courseId: '',
            courseName: this.$t('business_school.all_course'),
            sortData: [{
                key: '',
                name: this.$t('business_school.all_course')
            }],

        }
    },

    computed: {

        ...mapState({
            deviceType: state => state.common.deviceType,
        }),
        columnNum(){
            // 检查屏幕宽度是否小于768px（通常认为是移动设备的阈值）
            if (window.matchMedia("(max-width: 767px)").matches) {
                return 2; // 小于或等于768px认为是移动设备
                // return 'Mobile'; // 小于或等于768px认为是移动设备
            } else {
                return 3; // 大于768px认为是桌面设备
                // return 'Desktop'; // 大于768px认为是桌面设备
            }
        }
    },

    watch: {},
    created(){
        const header = JSON.parse(localStorage.getItem('header'))
        let lang = header['Blade-Lang']
        if(lang){
            console.log('lang',lang);
            this.$i18n.locale = lang
        }
        console.log(navigator.userAgent);
        this.$store.commit('common/changeDeviceType',this.detectDevice())
    },

    mounted() {
        this.$nextTick(() => {
        // 判断本地存储是否存在id,存在则跳转详情页
        let courseId = sessionStorage.getItem("courseId");
        if (courseId) {
            courseId = JSON.parse(courseId)
            this.toPage(`/learn-detail?id=${courseId}`)
            // sessionStorage.removeItem("courseId");
            // this.$router.push(`/learn-detail?id=${courseId}`)
        }
        });
        const app = document.getElementById('app');
        app.classList.add('school-index-class');
        const body = document.body;
        body.classList.add('school-index-body');
        this.getData()
        window.addEventListener('scroll', this.move, true)
    },

    methods: {
        exit() {
            if (window.h5_to_flutter) {
                window.h5_to_flutter.postMessage('exit')
            } else {
                console.error('h5_to_flutter is not defined');
                this.$utils.back();
            }
        },
        detectDevice() {
            if (window.innerWidth <= 768) {
                return 1;
            } else if (window.innerWidth > 768 && window.innerWidth <= 1024) {
                return 2;
            } else {
                return 3;
            }
        },
        async getData() {
            this.$store.commit("changeLoading", this.$t('text.loading'));
            let res = await this.$apis.school.getCourseTypeList()
            this.sortData = [{key:'',name:this.$t('business_school.all_course')},...res.data.list.map(item=>({key:item.id,name:item.typeName}))]

            this.$apis.school.getCourseBannerList({type:this.deviceType}).then(res => {
                this.bannerImg = res.data.map(item=>({title:item.courseName,img:item.preview,id:item.id}))
                this.$store.commit("changeLoading", false);
            }).catch(err => {
                this.$store.commit("changeLoading", false);
            })
            this.getCourseList()
        },
        getCourseList(){
            this.$apis.school.getCourseList({typeId:this.courseId}).then(res => {
                this.courses = res.data.list
                this.$store.commit("changeLoading", false);
            }).catch(err => {
                this.$store.commit("changeLoading", false);
            })
        },
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        },
        move() {
            this.pageScroll = true;
            let schoolIndex = this.$refs.schoolIndex;
            if(!schoolIndex) return
            const top = this.$utils.pt(schoolIndex.scrollTop, true)
            console.log('scrollTop',schoolIndex.scrollTop);
            // if (top>130) {
            //     this.isTop = true
            // } else {
            //     this.isTop = false
            // }
            if (schoolIndex.scrollTop>250) {
                this.isTop = true
            } else {
                this.isTop = false
            }

        },
        setSort(item) {
            this.courseId = item.key;
            this.courseName = item.name
            this.showSort  = false
            this.getCourseList()
        },

        onConfirm({ selectedValues, selectedOptions }) {
            this.showPicker = false;
            this.pickerValue = selectedValues;
            this.fieldValue = selectedOptions[0].text;
        },
    },

    beforeDestroy() {
        const app = document.getElementById('app');
        app.classList.remove('school-index-class');
        const body = document.body;
        body.classList.remove('school-index-body');
        window.removeEventListener('scroll', this.move, true);
    }
}
</script>

<style lang="scss" scoped>

.school-index {
    font-size: 14px;
    height: 100%;
    overflow: auto;
    background: #F4F5F8;
    .navBar{
        z-index: 10;
        height: 50px !important;
    }
    .isTop{
        width: 100%;
        z-index: 10;
        position: fixed;
        top:50px !important
    }
    .tabbar{
        height: 40px;
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: 10;
        box-sizing: border-box;
        padding: 5px 0;
        background: #fff;

    }
}
.content{
    margin-top: 50px;
    margin-bottom: 30px;
    height: calc(100vm - 90px);
    .swipe{
        display: inline-flex;
        height: 200px;
        .title{
            position: absolute;
            left: 10px;
            top: 10px;
            h4{
                color: #fff;
                text-align: left;
            }
            .button{
                display: block;
                line-height: 30px;
                width: 60px;
                max-width: 100px;
                background: transparent;
                border: #fff 1px solid;
            }
        }
        .TeacherApply{
            width: 30vw;
            background: #5d6072;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .van-icon{
                color: #fff;
                font-style: 14px;
            }
            .apply{
                color: #fff;
                h6{
                    font-weight: 900;
                }
                .button{
                    margin: 0 auto;
                    width: 50%;
                }
            }
        }
    }
    .grid{
        width: 100%;
        padding-top: 10px;
        box-sizing: border-box;
        .course{
            display: flex;
            flex-direction: column;
            .title{
                padding: 0 10px;
                margin: 5px 0;
                color: #000;
                text-align: left;
                font-size: 12px;
                line-height: 14px;
                overflow-wrap: break-word;
            }
            .tip{
                padding: 0 10px;
                color: #787D85;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .detailButton{
                    height: 24px;
                    line-height: 24px;
                    width: 35%;
                }
            }
        }
    }
}

.sorts {
    padding: 11px 16px;
    background-color: white;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.0500);
    box-sizing: border-box;

    .sort {
        font-size: 14px;
        // line-height: 22px;
        position: relative;
        color: #484C54;

        &.active {
            color: #E22F25;

            .triangle {
                font-size: 14px;
                color: #E22F25;
                transform: rotate(180deg);
            }
        }

        .triangle {
            height: 20px;
            position: relative;
            display: inline;
            top: 1px;
        }
    }

    .type {
        flex: 1;
        text-align: left;
        margin-left: 24px;
    }
}

.page-sort {
    top: 88px;
    height: calc(100% - 88px);
}
</style>
<style lang="scss">
.school-index {
    &::-webkit-scrollbar {
        display: none;
    }
    .project-sort{
        top: 8vh !important;
    }
    .navBar{
        font-size: 14px;
        font-weight: bold;
        .van-nav-bar__content{
            height: 100%;
        }
        i{
            // font-size: 14px !important;
            // line-height: 22px;
            color: #000 !important;
        }
        .van-nav-bar__left,.van-nav-bar__right{
            font-size: 14px;
            line-height: 22px;

        }
    }
    .content{
        .van-swipe{
            width: 70vw;
            // width: 100vw;
            .van-swipe__indicator{
                width: 6px;
                height: 6px;
            }
            .van-swipe__indicator--active{
                background-color: #fff;
            }
        }
        .van-grid-item__content{
            padding: 0 0 8px 0;
            border-radius: 8px;
            overflow: hidden;
            height: 100%;
        }
        .course{
            width: 100%;
            flex: 1;
            .coursePre{
                position: relative;
                height: 150px;
                // .van-image{
                //     width: 100%;
                //     height: 150px;
                // }
            }
        }
        .pic-info {
            position: absolute;
            bottom: 4px;
            left: 4px;
            z-index: 2;
            padding: 4px;
            display: flex;
            align-items: center;
            border-radius: 4px;
            overflow: hidden;
            // position: absolute;
            background: rgba(0, 0, 0, 0.4);
            .value {
                font-size: 10px;
                color: white;
                // font-weight: bold;
            }
        }
    }
    .tabbar{
        .footBtn{
            z-index: 11;
            width: 40%;
            margin-left: 50%;
            transform: translateX(-50%);
        }
    }
    // .page-sort{
    //     .sort-item{
    //         padding: 0 0 0 20px !important;
    //         height: 44px !important;
    //         line-height: 44px !important;
    //         border-bottom: 1px solid #787D85;
    //         .tick {
    //             width: 20px;
    //             height: 20px;
    //             margin-top: 6px;
    //             margin-right: 10px;
    //         }
    //     }
    // }
}
.school-index-class{
    .loading-content {
        width: 172px !important;
        height: 112px !important;
        border-radius: 8px !important;
        .icon {
            width: 40px !important;
            height: 40px !important;
            margin-top: 24px !important;
        }
        .text {
            font-size: 14px !important;
            line-height: 16px !important;
            margin-top: 6px !important;
        }
    }
}
.school-index-body {
    .project-message {
        width: 302px !important;
        bottom: calc(50% - 10px) !important;
        left: calc(50% - 152px) !important;
        line-height: 20px !important;
        font-size: 14px !important;
        &.middle {
            bottom: 50%;
        }
        .text {
            border-radius: 29.5px !important;
            padding: 12px 25px !important;
            &.login-msg {
                border-radius: 13px !important;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/pages/school/index.vue